module.exports = __webpack_public_path__ + "static/media/orgChart.23a30644.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/orgChart.png
// module id = 201
// module chunks = 0